import React from 'react';
import PublicLayout from '../components/PublicLayout';
import { useTranslation } from 'react-i18next';
import { TermsSEO } from '../components/SEO';
import { FloatingShapes } from '../components/icons/FeatureIcons';
import { FileText, Scale, AlertCircle } from 'lucide-react';

const Terms = () => {
  const { t } = useTranslation();
  const sections = [
    {
      title: t('pages.terms.termsTitle'),
      body: t('pages.terms.termsDesc'),
      Icon: FileText,
      gradient: 'from-purple-500 to-purple-600'
    },
    {
      title: t('pages.terms.scopeTitle'),
      body: t('pages.terms.scopeDesc'),
      Icon: Scale,
      gradient: 'from-blue-500 to-blue-600'
    },
    {
      title: t('pages.terms.responsibilityTitle'),
      body: t('pages.terms.responsibilityDesc'),
      Icon: AlertCircle,
      gradient: 'from-indigo-500 to-indigo-600'
    }
  ];

  return (
    <PublicLayout>
      <TermsSEO />
      
      {/* Hero Section */}
      <div className="relative bg-gradient-to-br from-purple-600 to-indigo-700 py-20 overflow-hidden">
        <FloatingShapes />
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center">
          <p className="text-sm font-semibold text-purple-200 uppercase tracking-wide mb-4">{t('footer.legal')}</p>
          <h1 className="text-4xl sm:text-5xl font-bold tracking-tight text-white mb-6">{t('pages.terms.title')}</h1>
          <p className="text-xl text-purple-100 max-w-2xl mx-auto">{t('pages.terms.subtitle')}</p>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16 -mt-10 relative z-10">
        <div className="space-y-6">
          {sections.map((section) => (
            <div key={section.title} className="p-6 border border-gray-100 rounded-2xl bg-white shadow-lg hover:shadow-xl transition-shadow">
              <div className="flex items-start gap-4">
                <div className={`w-12 h-12 rounded-xl bg-gradient-to-br ${section.gradient} flex items-center justify-center flex-shrink-0 shadow-lg`}>
                  <section.Icon className="w-6 h-6 text-white" />
                </div>
                <div>
                  <h2 className="text-xl font-semibold mb-2 text-gray-900">{section.title}</h2>
                  <p className="text-sm text-gray-700 leading-relaxed">{section.body}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
        </div>
    </PublicLayout>
  );
};

export default Terms;
